import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../store';
import api from '../../utils/api';

const AdminDashboard: React.FC = () => {
  const history = useHistory();
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const [stats, setStats] = useState({ users: 0, books: 0, reviews: 0 });
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查是否是管理员
    if (!isAuthenticated || user?.role !== 'admin') {
      alert('需要管理员权限');
      history.push('/');
      return;
    }

    fetchDashboard();
  }, [isAuthenticated, user, history]);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      const [statsRes, usersRes] = await Promise.all([
        api.get('/admin/dashboard'),
        api.get('/admin/users'),
      ]);
      
      setStats(statsRes.data.statistics);
      setUsers(usersRes.data);
    } catch (error) {
      console.error('获取管理数据失败:', error);
      alert('获取数据失败，请检查权限');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>加载中...</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>管理后台</h1>
      
      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '30px' }}>
        <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
          <h3 style={{ fontSize: '36px', color: '#1890ff', margin: '0' }}>{stats.users}</h3>
          <p style={{ color: '#666', margin: '10px 0 0' }}>注册用户</p>
        </div>
        <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
          <h3 style={{ fontSize: '36px', color: '#52c41a', margin: '0' }}>{stats.books}</h3>
          <p style={{ color: '#666', margin: '10px 0 0' }}>图书数量</p>
        </div>
        <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
          <h3 style={{ fontSize: '36px', color: '#faad14', margin: '0' }}>{stats.reviews}</h3>
          <p style={{ color: '#666', margin: '10px 0 0' }}>书评数量</p>
        </div>
      </div>

      {/* 功能模块 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '30px' }}>
        <div className="card" style={{ cursor: 'pointer' }} onClick={() => history.push('/admin/books')}>
          <h3>📚 图书管理</h3>
          <p style={{ color: '#666', marginTop: '8px' }}>管理所有图书、删除图书</p>
          <button className="btn btn-primary" style={{ marginTop: '12px' }}>
            进入管理
          </button>
        </div>
        
        <div className="card" style={{ cursor: 'pointer' }} onClick={() => history.push('/admin/import')}>
          <h3>📥 批量导入</h3>
          <p style={{ color: '#666', marginTop: '8px' }}>扫描目录、批量导入图书</p>
          <button className="btn btn-primary" style={{ marginTop: '12px' }}>
            开始导入
          </button>
        </div>

        <div className="card" style={{ cursor: 'pointer' }} onClick={() => history.push('/admin/categories')}>
          <h3>🏷️ 分类管理</h3>
          <p style={{ color: '#666', marginTop: '8px' }}>添加、编辑、删除图书分类</p>
          <button className="btn btn-primary" style={{ marginTop: '12px' }}>
            分类管理
          </button>
        </div>
        
        <div className="card" style={{ cursor: 'pointer' }} onClick={() => history.push('/books')}>
          <h3>👀 浏览书库</h3>
          <p style={{ color: '#666', marginTop: '8px' }}>查看图书展示效果</p>
          <button className="btn btn-default" style={{ marginTop: '12px' }}>
            查看书库
          </button>
        </div>
      </div>

      {/* 用户列表 */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2>用户管理</h2>
          <button 
            className="btn btn-default"
            onClick={fetchDashboard}
          >
            刷新数据
          </button>
        </div>
        
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #eee' }}>
              <th style={{ padding: '12px', textAlign: 'left' }}>ID</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>用户名</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>邮箱</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>角色</th>
              <th style={{ padding: '12px', textAlign: 'left' }}>注册时间</th>
            </tr>
          </thead>
          <tbody>
            {users.map((userItem) => (
              <tr key={userItem.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '12px' }}>{userItem.id}</td>
                <td style={{ padding: '12px' }}>{userItem.username}</td>
                <td style={{ padding: '12px' }}>{userItem.email}</td>
                <td style={{ padding: '12px' }}>
                  <span style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    background: userItem.role === 'admin' ? '#ff4d4f' : '#1890ff',
                    color: 'white',
                    fontSize: '12px',
                  }}>
                    {userItem.role === 'admin' ? '管理员' : '读者'}
                  </span>
                </td>
                <td style={{ padding: '12px' }}>
                  {new Date(userItem.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && (
          <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
            暂无用户数据
          </p>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
